<template>

   
    <!-- <input 
    type="file" 
    class="form-control"
    ref="file"
    @change="$emit('model-updated', $event, schema.model)"
    :config="model.options" > -->
    <el-upload
      class="upload-demo"
      drag
      ref="file"
      size="mini"
      action=""
      :file-list="fileList"
      list-type="picture"
      :on-change="function(file,fileList){
        $emit('model-updated', file, schema.model)
      }"
       :on-remove="function(file,fileList){
        deleteFile(file,fileList)
      }"
       multiple
      :auto-upload="false">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Cliquez ici pour joindre les fichiers </div>
      <div class="el-upload__tip" slot="tip">Fichiers jpg/png avec une taille inférieure à 500kb</div>
    </el-upload>
   <!-- <vs-upload multiple text="Upload Multiple" action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" /> -->

</template>

<script>
import { abstractField } from "vue-form-generator";
import firebase from 'firebase'


export default {
        mixins: [ abstractField],

        
       data(){
         return{
           storage: firebase.storage().ref(),
           fileList:[]
         }
       },
       methods:{

           deleteFile(file,fileList){
           this.fileList=fileList
           let image= firebase.storage().refFromURL(file.url)
           image.delete().then(()=>{
             console.log("Sucess")
           }).cath((error)=>{
             console.log("Error")
           })

           }
       }
      
};

</script>